import {css, html} from '@isceco/widget-library2/external/lit';
import WebComponent from '../../WebComponent.js';
import AuthorizationFilter from "../Authorization/AuthorizationFilter";
import './Navigation/AdminNavigation.js'
import Monitoring from "./Monitoring/Monitoring";
import Export from "./Export";
import Auditlog from "./Auditlog/Auditlog";
import Parameter from './Parameter.js'
import TechnischeKapazitaet from "./TechnischeKapazitaet";
import GebuchteKapazitaet from "./GebuchteKapazitaet";
import Kundensegmentierung from "./Kundensegmentierung";
import Angebot from "./Angebot/Angebot";
import Ml from './Ml.js'

export default class Admin extends WebComponent {

  get css() {
    return css`
      #adminNavigation {
        position: sticky;
        top: 200px;
        height: 0;
        width: 300px;
        overflow: visible;
      }

      #adminContent {
        padding-left: 300px;
      }
    `
  }

  get translationFile() {
    return './views/Admin/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()

    if (getNavigationHash() === 'Admin') {
      navigate({to: 'Admin_Monitoring'});
    }

    this.render()
  }

  getTemplate() {
    return html`
      <div id="adminNavigation">
        <gasmonitoring-frontend-admin-navigation></gasmonitoring-frontend-admin-navigation>
      </div>
      <div id="adminContent">
        ${this._getContent()}
      </div>
    `
  }

  _getContent() {  //NOSONAR
    // check the rights and redirect to default view in verwaltung if not ok
    if (!AuthorizationFilter.viewAllowed(getNavigationHash())) {
      navigate({to: ''})
      return html``
    }
    switch (getNavigationHash()) {
      case 'Admin_Parameter':
        return new Parameter()
      case 'Admin_Ml':
        return new Ml()
      case 'Admin_Tek':
        return new TechnischeKapazitaet()
      case 'Admin_Gek':
        return new GebuchteKapazitaet()
      case 'Admin_Angebot_Ego':
        return new Angebot()
      case 'Admin_Angebot_Egz':
        return new Angebot()
      case 'Admin_Angebot_Gaznat':
        return new Angebot()
      case 'Admin_Angebot_Gvm':
        return new Angebot()
      case 'Admin_Angebot_Ail':
        return new Angebot()
      case 'Admin_Seg':
        return new Kundensegmentierung()
      case 'Admin_Monitoring':
        return new Monitoring()
      case 'Admin_Export':
        return new Export()
      case 'Admin_Audit':
        return new Auditlog()
      default:
        break;
    }
    // default
    return html``
  }

}
customElements.define('gasmonitoring-frontend-admin', Admin)
